import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { AppState, AppActions } from '@/types'

type AppStore = AppState & AppActions

const useAppStore = create<AppStore>()(
  devtools(
    (set, get) => ({
      // Initial state
      theme: 'light',
      isLoading: false,
      error: null,
      mobileMenuOpen: false,
      turbineRefreshTrigger: 0,

      // Actions
      setTheme: (theme: 'light' | 'dark') => {
        set({ theme }, false, 'setTheme')
        localStorage.setItem('theme', theme)
      },

      setLoading: (loading: boolean) => {
        set({ isLoading: loading }, false, 'setLoading')
      },

      setError: (error: string | null) => {
        set({ error }, false, 'setError')
      },

      toggleMobileMenu: () => {
        set(
          { mobileMenuOpen: !get().mobileMenuOpen },
          false,
          'toggleMobileMenu'
        )
      },

      setMobileMenuOpen: (open: boolean) => {
        set({ mobileMenuOpen: open }, false, 'setMobileMenuOpen')
      },

      triggerTurbineRefresh: () => {
        set(
          { turbineRefreshTrigger: get().turbineRefreshTrigger + 1 },
          false,
          'triggerTurbineRefresh'
        )
      },
    }),
    {
      name: 'deepwind-app-store',
    }
  )
)

export default useAppStore 